var ContentLock = function() {
  var contentLock = function() {
    $(document).ready(function() {
      var contentLocked = $('.content-locked-container');
      if (contentLocked.length === 0) {
        return;
      }

      window.dataLayer.push({ event: 'notification_show', 'notification.type': 'odpoved lekare' });

      var loginButton = $(contentLocked).find('.buttons .login');
      var registrationButton = $(contentLocked).find('.buttons .registration');

      loginButton.click(function() {
        window.dataLayer.push({ event: 'button_click', 'button.type': loginButton.text() });
      });

      registrationButton.click(function() {
        window.dataLayer.push({ event: 'button_click', 'button.type': registrationButton.text() });
      });
    });
  };

  var init = function () {
    contentLock();
  };

  return {
    init: init
  }
}();

UL.register(ContentLock);